import request from "@/router/axios";

// 新增客户信用额度
export const add = (row) => {
  return request({
    url: "/api/produce/customer-credit-limit/add",
    method: "post",
    data: row,
  });
};

// 更新客户信用额度
export const update = (row) => {
  return request({
    url: "/api/produce/customer-credit-limit/update",
    method: "post",
    data: row,
  });
};

// 获取客户信用额度详情
export const getDetail = (id) => {
  return request({
    url: "/api/produce/customer-credit-limit/detail",
    method: "get",
    params: {
      id,
    },
  });
};

// 获取客户信用额度列表
export const getList = (data) => {
  return request({
    url: "/api/produce/data-statistics/selectCustCredit/page",
    method: "post",
    data,
  });
};

// 删除客户信用额度
export const remove = (id) => {
  return request({
    url: "/api/produce/customer-credit-limit/delete",
    method: "post",
    data: {
      id,
    },
  });
};

// 获取客户列表（用于下拉选择）
export const getCustomerList = () => {
  return request({
    url: "/api/produce/customer/select",
    method: "get",
  });
};

// 更新风险状态
export const updateRiskStatus = (data) => {
  return request({
    url: "/api/produce/customer-credit-limit/update-risk-status",
    method: "post",
    data,
  });
};
